// A project's `budget_type` decides whether "Budget used %" means anything.
// Only a Fixed Cost project has a total project budget to measure progress against;
// Time & Material and Contract projects are billed as work happens.

export const BUDGET_TYPE = {
  FIXED_COST: "FIXED_COST",
  TIME_AND_MATERIAL: "TIME_AND_MATERIAL",
  CONTRACT: "CONTRACT",
};

const LABELS = {
  [BUDGET_TYPE.FIXED_COST]: "Fixed Cost",
  [BUDGET_TYPE.TIME_AND_MATERIAL]: "Time & Material",
  [BUDGET_TYPE.CONTRACT]: "Contract",
};

// Why there is no budget % for each non-fixed type (shown to the user).
const EXPLANATIONS = {
  [BUDGET_TYPE.TIME_AND_MATERIAL]:
    "This project is billed on the time and materials used, so there is no fixed budget to measure progress against.",
  [BUDGET_TYPE.CONTRACT]:
    "This project is billed under a contract rather than a fixed project budget, so there is no budget percentage to track.",
};

const DEFAULT_EXPLANATION =
  "A budget percentage is only tracked for projects with a fixed project budget.";

// The project endpoint's payload is either the project itself or wrapped once
// more in `data`, depending on the caller; accept both.
export const getProjectBudgetType = (project) => {
  const raw = project?.budget_type ?? project?.data?.budget_type;
  return typeof raw === "string" && raw.trim() ? raw.trim().toUpperCase() : null;
};

export const getBudgetTypeLabel = (type) => LABELS[type] || null;

export const getBudgetNotTrackedMessage = (type) => EXPLANATIONS[type] || DEFAULT_EXPLANATION;

// Show the gauge for Fixed Cost projects. A project whose type was never set is a
// legacy record we cannot classify, so it keeps the gauge it always had rather than
// silently losing it.
export const shouldShowBudgetGauge = (type) => !type || type === BUDGET_TYPE.FIXED_COST;
